// ─── Zones de livraison (Dakar) ────────────────────────────────────────────
export const ZONES = [
  'Plateau',
  'Médina',
  'Parcelles Assainies',
  'Guédiawaye',
  'Pikine',
  'Rufisque',
  'Dakar Sacré-Cœur',
  'Point E',
  'Almadies',
  'Grand Yoff',
  'Liberté',
  'Ouakam',
  'Yoff',
  'Autre',
];

// ─── Statuts des colis ──────────────────────────────────────────────────────
export const STATUTS = {
  depot: {
    label: 'En dépôt',
    color: '#D97706',
    bg:    '#FEF3C7',
    dot:   '#D97706',
    icon:  '📦',
  },
  affecte: {
    label: 'Livreur affecté',
    color: '#0284C7',
    bg:    '#E0F2FE',
    dot:   '#0284C7',
    icon:  '🛵',
  },
  en_route: {
    label: 'En route',
    color: '#059669',
    bg:    '#D1FAE5',
    dot:   '#059669',
    icon:  '🚚',
  },
  livre: {
    label: 'Livré',
    color: '#047857',
    bg:    '#D1FAE5',
    dot:   '#047857',
    icon:  '🎉',
  },
  echec: {
    label: 'Échec livraison',
    color: '#DC2626',
    bg:    '#FEE2E2',
    dot:   '#DC2626',
    icon:  '❌',
  },
};

// Ordre des statuts pour la timeline de suivi
export const STATUT_ORDER = ['depot', 'affecte', 'en_route', 'livre'];

// ─── Modes de paiement ──────────────────────────────────────────────────────
export const PAIEMENTS = {
  wave:         { label: 'Wave',         icon: '💙' },
  orange_money: { label: 'Orange Money', icon: '🟠' },
  free_money:   { label: 'Free Money',   icon: '🟢' },
  cash:         { label: 'Espèces',      icon: '💵' },
};

// ─── Couleurs de la marque ──────────────────────────────────────────────────
export const BRAND = {
  primary:   '#4F46E5',
  secondary: '#8B5CF6',
  gradient:  'linear-gradient(135deg, #4F46E5 0%, #8B5CF6 100%)',
  dark:      '#1e1b4b',
};
